import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemServicoAppRoutingModule } from './item-servico.app-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ItemServicoAppRoutingModule
  ]
})
export class ItemServicoAppModule { }
